import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-CchwHdkN.js';
import { u as useLocalization } from '../chunks/bundle-BUBY2oxi.js';
import 'react-dom';
import '../chunks/bundle-CTudsbOB.js';
import '../chunks/bundle-Cy0THYtw.js';
import '../chunks/bundle-BEAYXWFj.js';
import '@sendbird/chat/groupChannel';
import '../utils/message/getOutgoingMessageState.js';
import '../chunks/bundle-0XYk-sLK.js';
import '../chunks/bundle-3PybmMNj.js';
import '../chunks/bundle-Dp84Y5uU.js';
import '../chunks/bundle-Cy_-UMph.js';
import '../chunks/bundle-Dmf3WkDZ.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '@sendbird/uikit-tools';
import '../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../chunks/bundle-BaAr93_S.js';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-C0hZDj23.js';
import '../useSendbirdStateContext.js';
import '../chunks/bundle-CNJeg2pQ.js';
import './SortByRow.js';
import '../chunks/bundle-D1cbmmT1.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
